import React from "react";
import AcquireWebComponent from "../framework/MaterialUI";
// import { isEmpty } from "lodash";
import {
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { splitNumber } from "../../utils/utility";

class LineGraphicSection extends AcquireWebComponent {
  isEmpty(data) {
    if (!data || data.length === 0) return true;
    if (data.length === 2) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].totalVisits > 0 || data[i].uniqueVisits > 0) return false;
      }
      return true;
    } else {
      return false;
    }
  }

  render() {
    const COLORS = ["#216E69", "#00A3AD", "#3888AB", "#87B7CD", "#AFCFDD"];
    const numberFormater = num => {
      return splitNumber(num + "")();
    };

    const CustomizedTooltip = React.createClass({
      render() {
        const { active } = this.props;
        if (active) {
          const { payload, label, formatter } = this.props;
          return (
            <div
              className="recharts-default-tootip no-margin p-10"
              style={{ background: "#FFFCDC", border: "solid 1px #ccc" }}
            >
              <p className="recharts-tooltip-label no-margin">{label}</p>
              <ul className="recharts-tooltip-item-list no-padding no-margin">
                <li
                  className="recharts-tooltip-item"
                  style={{
                    display: "block",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                    color: payload ? payload[0].stroke : "#FFF",
                  }}
                >
                  <span className="recharts-tooltip-item-name">
                    {payload && payload[0] ? payload[0].name : ""}
                  </span>
                  <span className="recharts-tooltip-item-separator"> : </span>
                  <span className="recharts-tooltip-item-value">
                    {payload && payload[0] ? formatter(payload[0].value) : ""}
                  </span>
                </li>
                <li
                  className="recharts-tooltip-item"
                  style={{
                    display: "block",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                    color: payload[1].stroke,
                  }}
                >
                  <span className="recharts-tooltip-item-name">
                    {payload[1].name}
                  </span>
                  <span className="recharts-tooltip-item-separator"> : </span>
                  <span className="recharts-tooltip-item-value">
                    {payload && payload.length > 1
                      ? formatter(payload[1].value)
                      : ""}
                  </span>
                </li>
              </ul>
            </div>
          );
        }

        return null;
      },
    });

    const { title, data, subTitle } = this.props;
    if (this.isEmpty(data)) {
      return (
        <div>
          <div
            style={{
              fontSize: "24px",
              lineHeight: "18px",
              marginBottom: "20px",
              fontWeight: "bold",
            }}
          >
            {title}
          </div>

          <div
            style={{
              width: "100%",
              minHeight: "200px",
              textAlign: "center",
              paddingTop: "60px",
              color: "#CDCDCD",
            }}
          >
            <div style={{ color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" }}>
              No Data
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="line-graphic-section">
        <div
          style={{
            fontSize: "24px",
            marginBottom: "40px",
            fontWeight: "bold",
          }}
        >
          {title}
        </div>
        <ResponsiveContainer width="100%" height="80%" minHeight={200}>
          <LineChart
            data={data}
            margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
          >
            <XAxis
              dataKey="time" 
              padding={{ left: 30, right: 30 }} 
              interval="preserveStartEnd" 
              minTickGap={12}
            />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <Tooltip
              formatter={numberFormater}
              content={<CustomizedTooltip />}
            />
            <Legend layout="horizontal" verticalAlign="top" align="left" />
            <Line
              isAnimationActive={this.props.animation}
              name={
                this.props.type === "business"
                  ? "Total Domestic Visits"
                  : "Total Visits"
              }
              type="monotone"
              dataKey="totalVisits"
              strokeWidth={5}
              stroke={COLORS[0]}
              activeDot={{ r: 1 }}
            />
            <Line
              isAnimationActive={this.props.animation}
              name={
                this.props.type === "business"
                  ? "Unique Domestic Visits"
                  : "Unique Visits"
              }
              type="monotone"
              dataKey="uniqueVisits"
              strokeWidth={5}
              stroke={COLORS[1]}
              activeDot={{ r: 1 }}
            />
          </LineChart>
        </ResponsiveContainer>
        <div className="text-center">
          <strong>Date: </strong>{subTitle}
        </div>
      </div>
    );
  }
}

LineGraphicSection.propTypes = {
  title: React.PropTypes.string.isRequired,
  data: React.PropTypes.array,
  subTitle: React.PropTypes.string,
  type: React.PropTypes.string,
};

export default LineGraphicSection;



// WEBPACK FOOTER //
// ./src/components/Insights/LineGraphic.jsx